import { useMemo } from 'react';

import type { Row } from '@/ui/table/table.types';
import { useTranslateHeaders } from '@/ui/table/helpers/use-translate-headers';

import { styled } from 'goober';
import { templatesTableHeaders } from './templates-table-configuration';
import { TemplateLink } from './template-link';
import { TemplateUploadButton } from './template-upload-button';
import { TemplateUploadDate } from './template-upload-date';
import { useTemplatesOrder } from '../use-templates-order';
import type { TemplateSortKey } from '../account-management.state';

export const useTemplatesTableConfiguration = () => {
  const templates = useTemplatesOrder();

  const header = useTranslateHeaders<TemplateSortKey>(
    templatesTableHeaders,
    'settings',
  );

  const rows: Row[] = useMemo(() => {
    return templates.map(template => {
      return {
        id: template.fileType,
        cells: [
          {
            value: (
              <TemplateLink
                template={template.template}
                fileType={template.fileType}
              />
            ),
          },
          {
            value: (
              <CellContainer>
                {template.template ? (
                  <TemplateUploadDate template={template.template} />
                ) : (
                  <TemplateUploadButton fileType={template.fileType} />
                )}
              </CellContainer>
            ),
            width: '20px',
          },
        ],
      };
    });
  }, [templates]);

  return {
    rows,
    header,
  };
};

const CellContainer = styled('div')`
  max-width: 400px;
  ${({ theme }) => theme.mixins.ellipsis}
`;
